import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import img1 from "../assests/images/pricing/icon1.png";
import img2 from "../assests/images/pricing/icon2.png";
import img3 from "../assests/images/pricing/icon3.png";

const plans = [
  {
    imgSrc: img1,
    header: "Personal",
    blurb: "For solo learners getting started.",
    features: ["Custom domains", "Sleeps after 30 mins of inactivity"],
    price: "Free",
    buttonText: "Start free",
    isFeatured: false,
    link: "/payment?key1=Personal&key2=Free",
  },
  {
    imgSrc: img2,
    header: "Small team",
    blurb: "For friends or classes studying together.",
    features: ["Never sleeps", "Multiple workers for more powerful apps"],
    price: "$150",
    buttonText: "Start trial",
    isFeatured: true,
    link: "/payment?key1=Small+Team&key2=150",
  },
  {
    imgSrc: img3,
    header: "Enterprise",
    blurb: "For schools and larger groups.",
    features: ["Dedicated", "Simple horizontal scalability"],
    price: "$400",
    buttonText: "Start trial",
    isFeatured: false,
    link: "/payment?key1=Enterprise&key2=400",
  },
];

function PriceTiers() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="relative min-h-[calc(100vh-72px)] overflow-hidden bg-brand-surface">
      <div
        className="pointer-events-none absolute -left-24 top-10 h-72 w-72 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.18),transparent_70%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(10,43,30,0.08),transparent_72%)]"
        aria-hidden="true"
      />

      <section className="relative py-12 md:py-16">
        <Container>
          <div className="mx-auto mb-10 max-w-[560px] animate-fade-up text-center">
            <p className="section-label">Subscription</p>
            <h1 className="mb-3 font-display text-[clamp(2rem,4vw,2.8rem)] font-extrabold tracking-tight text-brand-forest">
              Choose a plan that fits your pace
            </h1>
            <p className="m-0 text-[1.05rem] leading-relaxed text-brand-muted">
              Start free, then scale up when you need more power for your study tools.
            </p>
          </div>

          <div className="mx-auto grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-3">
            {plans.map((plan, index) => (
              <Link
                key={plan.header}
                to={plan.link}
                className={`group relative flex flex-col rounded-[22px] border bg-white p-6 no-underline shadow-brand transition hover:-translate-y-1 hover:shadow-[0_22px_50px_rgba(10,43,30,0.12)] ${
                  plan.isFeatured
                    ? "border-brand-teal/50 ring-2 ring-brand-teal/20"
                    : "border-brand-forest/10 hover:border-brand-teal/35"
                } ${
                  index === 0
                    ? "animate-fade-up-1"
                    : index === 1
                      ? "animate-fade-up-2"
                      : "animate-fade-up-3"
                }`}
              >
                {plan.isFeatured && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand-teal px-3 py-1 font-display text-xs font-semibold text-white">
                    Popular
                  </span>
                )}

                <div className="mb-5 flex h-16 items-center justify-center">
                  <img
                    src={plan.imgSrc}
                    alt=""
                    className="max-h-14 w-auto object-contain transition group-hover:scale-105"
                  />
                </div>

                <h2 className="mb-1 text-center font-display text-xl font-bold normal-case tracking-tight text-brand-forest">
                  {plan.header}
                </h2>
                <p className="mb-5 text-center text-sm leading-relaxed text-brand-muted">
                  {plan.blurb}
                </p>

                <p className="mb-5 text-center font-display text-[2.4rem] font-extrabold leading-none text-brand-teal-dark">
                  {plan.price}
                </p>

                <ul className="mb-6 flex-1 list-none space-y-2.5 p-0">
                  {plan.features.map((feature) => (
                    <li
                      key={feature}
                      className="flex items-start gap-2 font-display text-sm font-medium normal-case leading-snug text-brand-forest"
                    >
                      <i className="ri-check-line mt-0.5 text-base text-brand-teal" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <span
                  className={`inline-flex items-center justify-center rounded-full px-6 py-3 text-center font-display text-[0.95rem] font-semibold transition ${
                    plan.isFeatured
                      ? "bg-brand-teal text-white group-hover:bg-brand-teal-dark"
                      : "border border-brand-teal/40 text-brand-teal-dark group-hover:bg-brand-soft"
                  }`}
                >
                  {plan.buttonText}
                </span>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </main>
  );
}

export default PriceTiers;
